module.exports = __webpack_public_path__ + "static/media/Orinocco95.e5a171c9.jpg";